import * as React from 'react';
import { connect } from 'react-redux';

import { ButtonSpinner, DropdownInput, } from '../../../Shared/index';
import * as CustomizeIntf from '../../interfaces/customize';

interface EditionRowState {
  isLoading: boolean
}

interface EditionRowProps {
  edition: CustomizeIntf.EditionMetadata
  archiveEdition?: Function
  creator: string
  editEdition?: Function
  makeNewEdition: Function
  selectAction: Function
  selectState: string|boolean|null
  selectedEdition: boolean
}

export interface AppProps extends EditionRowProps, DispatchFromProps, StateFromProps{

}
class EditionRow extends React.Component<AppProps, EditionRowState> {
  constructor(props) {
    super(props)

    this.state = {
      isLoading: false
    }
  }

  handleClickMakeNewEdition = () => {
    const { makeNewEdition, edition, } = this.props

    makeNewEdition(edition.key)
  }

  handleClickEditEdition = () => {
    const { editEdition, edition, } = this.props

    if (editEdition) {
      editEdition(edition.key)
    }
  }

  handleClickArchiveEdition = () => {
    const { archiveEdition, edition, } = this.props

    if (window.confirm('Are you sure you want to delete this edition? By deleting the edition, you will lose all the changes that you made to the slides.') && archiveEdition) {
      archiveEdition(edition.key)
    }
  }

  handleSelectAction = () => {
    const { selectAction, edition, } = this.props

    this.setState({ isLoading: true })
    selectAction(edition.key)
  }

  customizeOptions = () => {
    const { creator, } = this.props

    const options = [{ label: 'Make Copy', value: 'makeCopy' }]
    if (creator === 'user') {
      options.push({ label: 'Edit Edition', value: 'editEdition' })
      options.push({ label: 'Delete Edition', value: 'archiveEdition' })
    }
    return options
  }

  handleCustomizeChange = (selection) => {
    switch (selection.value) {
      case 'makeCopy':
        this.handleClickMakeNewEdition()
        break
      case 'editEdition':
        this.handleClickEditEdition()
        break
      case 'archiveEdition':
        this.handleClickArchiveEdition()
        break
      default:
        break
    }
  }

  renderCustomizeDropdown = () => (
    <DropdownInput
      ariaLabel="Customize"
      className="customize-dropdown small bordered"
      handleChange={this.handleCustomizeChange}
      isSearchable={false}
      options={this.customizeOptions()}
      placeholder="Customize"
      value={null}
    />
  )

  renderSelectButton() {
    const { selectState, selectedEdition, } = this.props
    const { isLoading, } = this.state

    if (selectState) {
      if (selectedEdition) {
        return (
          <button
            className="quill-button contained green medium focus-on-light resume-button"
            disabled={isLoading}
            onClick={this.handleSelectAction}
            type="button"
          >
            {isLoading ? <ButtonSpinner /> : 'Resume'}
          </button>
        )
      } else {
        return (
          <button
            className="quill-button contained green medium focus-on-light select-button"
            disabled={isLoading}
            onClick={this.handleSelectAction}
            type="button"
          >
            {isLoading ? <ButtonSpinner /> : 'Select'}
          </button>
        )
      }
    }
  }

  renderCreatedByTag() {
    const { customize, edition, } = this.props

    const teacher = customize.coteachers.find(t => t.id === edition.user_id)
    const name = teacher ? teacher.name : null
    if (name) {
      return <span className='locked-unit'>  <i className="fa fa-icon fa-user" />{name}</span>
    }
  }

  render() {
    const { edition, selectedEdition, creator, } = this.props

    const name = edition.name ? edition.name : 'Generic Content'
    const createdByTag = creator === 'coteacher' ? this.renderCreatedByTag() : null
    const sampleQuestionSection = edition.sample_question ? <p className="sample-question"><span>Sample Question: </span>{edition.sample_question}</p> : null
    const selectedEditionClass = selectedEdition ? 'selected' : ''
    const selectedEditionTag = selectedEdition ? <span className="in-progress"><i className="fa fa-icon fa-clock-o" />In Progress</span> : null
    return (
      <div className="edition-container">
        <div className={`edition ${selectedEditionClass}`}>
          <div className="text">
            <div className="name-section"><p className="name">{name}</p>{createdByTag}</div>
            {sampleQuestionSection}
          </div>
          <div className="action">
            {this.renderCustomizeDropdown()}
            {this.renderSelectButton()}
          </div>
        </div>
        {selectedEditionTag}
      </div>
    )

  }
}

function select(state) {
  return {
    customize: state.customize,
    classroomLesson: state.classroomLesson
  }
}

function mergeProps(stateProps: Object, dispatchProps: Object, ownProps: Object) {
  return {...ownProps, ...stateProps, ...dispatchProps}
}

export interface DispatchFromProps {

}

export interface StateFromProps {
  customize: any
  classroomLesson: any
}

export default connect<StateFromProps, DispatchFromProps, EditionRowProps>(select)(EditionRow)
